<template>
    <div class="container">
        <div class="flex-wrap flex-between wrap" style="font-size:16px;height:50px;">
          <div class="flex-wrap">
            <template v-for="(g,i) in groups">
              <div
                :key="'group_'+g.key"
                class="group-item flex-wrap"
                :class="{'group-actived':g.key == selected}"
                @click="selected = g.key;getData()"
              >
                {{g.name}}
                <div class="group-item-count">{{item_counts[g.key] || 0}}</div>
                <Divider type="vertical" v-if="i !== groups.length-1" />
              </div>
            </template>
          </div>
          <div class="flex-wrap">
            <Input clearable search v-model="searchText" />
            <a style="white-space:nowrap;width:140px;text-align:center;" @click="RouteTo(`/core/training-admin/videos`,true)">管理后台</a>
          </div>
        </div>
        <div style="overflow-y:auto;height:calc(100% - 100px);width:100%;position:relative;">
            <div
          class="flex-wrap align-start wrap"
          style="flex-wrap:wrap;position:relative;border-top:1px solid var(--border);padding:10px;align-items:stretch;"
        >
            <BaseEmpty style="height:500px" v-if="items.length == 0"></BaseEmpty>
            <template v-else>
              <template v-for="item in filteredItems">
                <component :is="selectedItemControl" @on-open="open(item,$event)" :value="item" :key="item.id"  />
              </template>
            </template>
          </div>

        </div>

      <div class="wrap flex-wrap flex-center" style="margin-top:10px">

        <Page :total="item_counts[selected]" :current="pages[selected]" :page-size="32" @on-change="pages[selected]=$event;getData()" show-elevator size="small" />
      </div>
      <Modal v-model="showVideo" :title="current?(current.name || '视频播放'):'视频播放'" :width="1000" footer-hide>
        <div class="flex-wrap" style="width:100%;align-items:stretch;">
          <BaseEmpty v-if="!current || !current.video_url || !current.siblings || current.siblings.length == 0" style="width:100%;height:400px;">
            本专辑还未上传视频
          </BaseEmpty>
          <template v-else>
        <video :src="current?current.video_url:''" style="width:calc(100% - 200px);flex-shrink:1;flex-grow:1;" controls></video>
          </template>
        <div style="width:200px;flex-shrink:0;margin-left:5px;background:var(--border);overflow:hidden;overflow-y:auto;" v-if="current && current.siblings && current.siblings.length > 0">

          <div v-for="(r,index) in current.siblings" :key="r.id">
            <div :key="r.id" :class="{
                'l-record':true,
                'l-record-actived':r.id == current.id
              }"
              @click="changeVideo(r)"
            >
              {{index+1}} - {{ r.name }}
            </div>
          </div>
        </div>
      </div>
      </Modal>
    </div>
  </template>

<script>
import TrainingProject from '@/components/training/project';
import TrainingMyProject from '@/components/training/myproject';
import TrainingClass from '@/components/training/class';
import TrainingGroup from '@/components/training/group';
import TrainingTeacher from '@/components/training/teacher';
import TrainingCategory from '@/components/training/category';
export default {
  components: {
    TrainingProject,
    TrainingMyProject,
    TrainingClass,
    TrainingGroup,
    TrainingTeacher,
    TrainingCategory,
  },
  data() {
    return {
      pagesize: 32,
      pages:{
        Project: 1,
        MyProject: 1,
        Class: 1,
        Group: 1,
        Teacher: 1,
      },
      selected: 'Class',
      searchText: '',
      showVideo:false,
      current:null,
      item_counts: {
        Project: 0,
        MyProject: 5,
        Class: 1,
        Group: 2,
        Teacher: 3,
      },
      pagesize: 30,
      groups: [{
        key: 'Class',
        name: '视频列表',
        type:'classes'
      },
      {
        key:'Group',
        name:'专辑',
        type:'collections'
      }
      ],
      used: [
        {
          key: 'Project',
          name: '培训报名',
        },
        {
          key: 'MyProject',
          name: '我的培训',
        },
        {
          key: 'Class',
          name: '课程',
        },
        {
          key: 'Group',
          name: '合辑',
        },
        {
          key: 'Teacher',
          name: '讲师',
        },
        {
          key: 'Category',
          name: '分类',
        },
      ],
      items: [
        {
          tags: ['青藤班'],
          name: '桩基检测解读',
          teacher_id: 'ugo',
          created_at: '2022/09/12',
          created_by: 'ugo',
          student_counts: 32,
          state: 0,
          place: '14楼多功能会议室',
          avatar: '',
        },
      ],
    };
  },
  computed: {
    selectedItemControl() {
      return 'Training' + this.selected;
    },
    filteredItems(){
      if(this.searchText && this.searchText.trim() != '')
        return this.items.filter((item)=>{
          return item.name && item.name.includes(this.searchText) || item.project && item.project.name && item.project.name.includes(this.searchText);
        })
      else
        return this.items
    }
  },
  mounted() {
    this.Login(this.$route.query.uid)
   
  },
  methods: {
    Login(uid) {
        this.is_ready = false;
        this.$store.dispatch('session/login_zzl', {uid}).then((res)=>{
            this.getCounts();
            setTimeout(this.getData, 300);
            setTimeout(this.getCollections, 300);
        }).catch((e)=>{
          this.Error('登录失败,启用离线模式');
        }).finally(()=>{
          this.is_ready = true;
        });
      },
    getCounts(){
      this.$api.get(`study/counts`).then((res) => {
        this.item_counts = res.data.data
      });
    },
    changeVideo(r){
      r.siblings = this.current.siblings
      this.current = r
    },
    getData() {
      this.items = []
      this.loading = true;
      let page = this.pages[this.selected]
      let pagesize = this.pagesize
      this.selectedType = this.groups.find((g)=>g.key == this.selected).type;
      this.$api.get(`study/${this.selectedType}?related=project&order=created_at&desc=1&page=${page}&pagesize=${pagesize}`).then((res) => {
        this.items = res.data.data;
      }).finally(()=>{
        this.loading = false;
      });
    },
    getCollections() {
      this.$api.get('study/collections?related=classes&order=created_at&desc=1&page=1&pagesize=32').then((res) => {
        this.collections = res.data.data;
      });
    },
    open(item){
      this.showVideo = true;
      this.loading = true
        this.$api.get(`study/${this.selectedType}/${item.id}?q=related`).then((res) => {
          this.current = res.data.data;
        }).finally(()=>{
          this.loading = false;
        });
    },
  },
};
</script>
<style lang="less" scoped>
  .group-item-count {
    padding: 1px 5px;
    font-size: 12px;
    margin-left: 5px;
    border-radius: 50%;
    background: var(--bg2);
    color: var(--text2);
  }

  .group-actived {
    color: var(--primary);
  }

  
.l-record{
  min-height:40px;padding:5px;
  display: flex;
  align-items: center;
  white-space: pre-wrap;
}

.l-record:hover{
  color:var(--primary);
  cursor:pointer;
}

.l-record-actived,.l-record-actived:hover{
  background:var(--primary);
  color:var(--hover-text);
}
  </style>
